import { isRouteRef } from '../typesActions/types';

export const addRefRouteAction = (value) => {
	return { type: isRouteRef.SELECTED_ROUTE, payload: value };
};
